import { computed, Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LayoutService {
    private readonly _overflowHidden = signal<boolean>(false);

    /** Readonly view for the shell to consume. */
    public readonly overflowHidden = computed(() => this._overflowHidden());

    public setOverflowHidden(hidden: boolean): void {
        this._overflowHidden.set(hidden);
    }
}
